// CacheKey 5ae91f3796c5f22fef58a493a6cdd2db
//
// DO NOT MODIFY: This file was automatically generated by JsFromEnums.
export default {
  all: [
    { label: 'Afrikaans', value: 'afrikaans', metadata: { code: 'af' } },
    { label: 'Albanian', value: 'albanian', metadata: { code: 'sq' } },
    { label: 'Amharic', value: 'amharic', metadata: { code: 'am' } },
    { label: 'Arabic', value: 'arabic', metadata: { code: 'ar' } },
    { label: 'Armenian', value: 'armenian', metadata: { code: 'hy' } },
    { label: 'Azerbaijani', value: 'azerbaijani', metadata: { code: 'az' } },
    { label: 'Bantu', value: 'bantu', metadata: { code: 'bnt' } },
    { label: 'Belarusian', value: 'belarusian', metadata: { code: 'be' } },
    { label: 'Bengali', value: 'bengali', metadata: { code: 'bn' } },
    { label: 'Bosnian', value: 'bosnian', metadata: { code: 'bs' } },
    { label: 'Bulgarian', value: 'bulgarian', metadata: { code: 'bg' } },
    { label: 'Burmese', value: 'burmese', metadata: { code: 'my' } },
    { label: 'Cantonese', value: 'cantonese', metadata: { code: 'zh' } },
    { label: 'Cebuano', value: 'cebuano', metadata: { code: 'ceb' } },
    { label: 'Croatian', value: 'croatian', metadata: { code: 'hr' } },
    { label: 'Czech', value: 'czech', metadata: { code: 'cs' } },
    { label: 'Danish', value: 'danish', metadata: { code: 'da' } },
    { label: 'Dutch', value: 'dutch', metadata: { code: 'nl' } },
    { label: 'English', value: 'english', metadata: { code: 'en' } },
    { label: 'Estonian', value: 'estonian', metadata: { code: 'et' } },
    { label: 'Farsi', value: 'farsi', metadata: { code: 'fa' } },
    { label: 'Filipino', value: 'filipino', metadata: { code: 'fil' } },
    { label: 'Finnish', value: 'finnish', metadata: { code: 'fi' } },
    { label: 'French', value: 'french', metadata: { code: 'fr' } },
    { label: 'Galician', value: 'galician', metadata: { code: 'gl' } },
    { label: 'Georgian', value: 'georgian', metadata: { code: 'ka' } },
    { label: 'German', value: 'german', metadata: { code: 'de' } },
    { label: 'Greek', value: 'greek', metadata: { code: 'el' } },
    { label: 'Gujarati', value: 'gujarati', metadata: { code: 'gu' } },
    { label: 'Haitian Creole', value: 'haitian_creole', metadata: { code: 'ht' } },
    { label: 'Hebrew', value: 'hebrew', metadata: { code: 'he' } },
    { label: 'Hindi', value: 'hindi', metadata: { code: 'hi' } },
    { label: 'Hmong', value: 'hmong', metadata: { code: 'hmn' } },
    { label: 'Hungarian', value: 'hungarian', metadata: { code: 'hu' } },
    { label: 'Icelandic', value: 'icelandic', metadata: { code: 'is' } },
    { label: 'Indonesian', value: 'indonesian', metadata: { code: 'id' } },
    { label: 'Italian', value: 'italian', metadata: { code: 'it' } },
    { label: 'Japanese', value: 'japanese', metadata: { code: 'ja' } },
    { label: 'Javanese', value: 'javanese', metadata: { code: 'jv' } },
    { label: 'Kannada', value: 'kannada', metadata: { code: 'kn' } },
    { label: 'Khmer', value: 'khmer', metadata: { code: 'km' } },
    { label: 'Konkani', value: 'konkani', metadata: { code: 'kok' } },
    { label: 'Korean', value: 'korean', metadata: { code: 'ko' } },
    { label: 'Lao', value: 'lao', metadata: { code: 'lo' } },
    { label: 'Latin', value: 'latin', metadata: { code: 'la' } },
    { label: 'Latvian', value: 'latvian', metadata: { code: 'lv' } },
    { label: 'Lithuanian', value: 'lithuanian', metadata: { code: 'lt' } },
    { label: 'Lu Mien', value: 'lu_mien', metadata: { code: 'yao' } },
    { label: 'Luxembourgish', value: 'luxembourgish', metadata: { code: 'lb' } },
    { label: 'Macedonian', value: 'macedonian', metadata: { code: 'mk' } },
    { label: 'Maithili', value: 'maithili', metadata: { code: 'mai' } },
    { label: 'Malagasy', value: 'malagasy', metadata: { code: 'mg' } },
    { label: 'Malay', value: 'malay', metadata: { code: 'ms' } },
    { label: 'Malayalam', value: 'malayalam', metadata: { code: 'ml' } },
    { label: 'Mandarin', value: 'mandarin', metadata: { code: 'zh' } },
    { label: 'Marathi', value: 'marathi', metadata: { code: 'mr' } },
    { label: 'Mongolian', value: 'mongolian', metadata: { code: 'mn' } },
    { label: 'Navajo', value: 'navajo', metadata: { code: 'nv' } },
    { label: 'Nepali', value: 'nepali', metadata: { code: 'ne' } },
    { label: 'Norwegian', value: 'norwegian', metadata: { code: 'nb' } },
    { label: 'Odia', value: 'odia', metadata: { code: 'or' } },
    { label: 'Pashto', value: 'pashto', metadata: { code: 'ps' } },
    { label: 'Polish', value: 'polish', metadata: { code: 'pl' } },
    { label: 'Portuguese', value: 'portuguese', metadata: { code: 'pt' } },
    { label: 'Punjabi', value: 'punjabi', metadata: { code: 'pa' } },
    { label: 'Romanian', value: 'romanian', metadata: { code: 'ro' } },
    { label: 'Russian', value: 'russian', metadata: { code: 'ru' } },
    { label: 'Serbian', value: 'serbian', metadata: { code: 'sr' } },
    { label: 'Sindhi', value: 'sindhi', metadata: { code: 'sd' } },
    { label: 'Sinhala', value: 'sinhala', metadata: { code: 'si' } },
    { label: 'Slovak', value: 'slovak', metadata: { code: 'sk' } },
    { label: 'Slovenian', value: 'slovenian', metadata: { code: 'sl' } },
    { label: 'Somali', value: 'somali', metadata: { code: 'so' } },
    { label: 'Spanish', value: 'spanish', metadata: { code: 'es' } },
    { label: 'Swahili', value: 'swahili', metadata: { code: 'sw' } },
    { label: 'Swedish', value: 'swedish', metadata: { code: 'sv' } },
    { label: 'Tagalog', value: 'tagalog', metadata: { code: 'tl' } },
    { label: 'Tamil', value: 'tamil', metadata: { code: 'ta' } },
    { label: 'Telugu', value: 'telugu', metadata: { code: 'te' } },
    { label: 'Thai', value: 'thai', metadata: { code: 'th' } },
    { label: 'Turkish', value: 'turkish', metadata: { code: 'tr' } },
    { label: 'Ukrainian', value: 'ukrainian', metadata: { code: 'uk' } },
    { label: 'Urdu', value: 'urdu', metadata: { code: 'ur' } },
    { label: 'Vietnamese', value: 'vietnamese', metadata: { code: 'vi' } },
  ],
}
